module.exports = new __parcel__URL__("robot.fdf311ba.svg").toString();